/* This example requires Tailwind CSS v2.0+ */
import { ExclamationCircleIcon, XIcon } from "@heroicons/react/solid";
import clsx from "clsx";
import { FC } from "react";

interface Props {
  message: string;
  setShow: (value: boolean) => void;
  classes?: string;
}

const AlertError: FC<Props> = ({ classes, message, setShow }) => {
  return (
    <div className={clsx("tw-rounded-md tw-bg-red-50 tw-p-4", classes)}>
      <div className="tw-flex">
        <div className="tw-flex-shrink-0">
          <ExclamationCircleIcon
            className="tw-h-5 tw-w-5 tw-text-red-400"
            aria-hidden="true"
          />
        </div>
        <div className="tw-ml-3">
          <p className="tw-text-sm tw-font-medium tw-text-red-600">{message}</p>
        </div>
        <div className="tw-ml-auto tw-pl-3">
          <div className="-tw-mx-1.5 -tw-my-1.5">
            <button
              type="button"
              onClick={() => setShow(false)}
              className="tw-inline-flex tw-bg-red-50 tw-rounded-md tw-p-1.5 tw-text-red-500 hover:tw-bg-red-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-offset-red-50 focus:tw-ring-red-600"
            >
              <span className="tw-sr-only">Dismiss</span>
              <XIcon className="tw-h-5 tw-w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AlertError;
